import { c as _c } from "react/compiler-runtime";
import { AdSlot } from "@/components/AdSlot";
const rail = "sticky top-6 mt-6 hidden shrink-0 xl:block";

/** [left rail 160px] [content max 1040px] [right rail 160px].
 *  Rails show only at ≥1280 px; below that pages place one inline AdSlot
 *  between sections instead. */
export function AdLayout(t0) {
  const $ = _c(6);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AdSlot position="left" className={rail} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div className="w-full max-w-[1040px] min-w-0 flex-1">{children}</div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <AdSlot position="right" className={rail} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <div className="mx-auto flex w-full max-w-[1440px] items-start justify-center gap-6 px-4 sm:px-6 xl:px-4">{t1}{t2}{t3}</div>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}